import React, { useState } from 'react';
import styles from './TaskItem.module.css';
import Reward from '../Reward/Reward';
import type { DailyTask } from '../../types/Tasks/tasks';
import { ReactComponent as CoolDownIcon } from '../../assets/cooldownIcon.svg';
import { TimeDisplay } from '../../utils/TimeDisplay';
import ButtonLoader from '../ButtonLoader/ButtonLoader';
import ProgressBar from '../ProgressBar/ProgressBar';
const TaskItem = ({
  task,
  onClick,
  progress,
  allProgress,
  icon,
}: {
  task: DailyTask;
  onClick?: () => void;
  progress: number;
  allProgress: number,
  icon?: React.ReactNode;
}) => {
  const [isProcessing, setIsProcessing] = useState(false);

  const handleClick = async () => {
    if (isProcessing || !onClick) return; // Блокируем повторные клики

    setIsProcessing(true);
    try {
      await onClick();
    } catch (error) {
      console.error('Ошибка при выполнении задания:', error);
    } finally {
      // Добавляем небольшую задержку для предотвращения случайных двойных кликов
      setTimeout(() => {
        setIsProcessing(false);
      }, 100);
    }
  };

  const getFirstLetter = (title: string) => {
    // Регулярное выражение для проверки эмодзи
    const emojiRegex =
      /[\u{1F600}-\u{1F64F}]|[\u{1F300}-\u{1F5FF}]|[\u{1F680}-\u{1F6FF}]|[\u{1F1E0}-\u{1F1FF}]|[\u{2600}-\u{26FF}]|[\u{2700}-\u{27BF}]|[\u{1F900}-\u{1F9FF}]|[\u{1F018}-\u{1F270}]|[\u{238C}-\u{2454}]|[\u{20D0}-\u{20FF}]|[\u{FE00}-\u{FE0F}]|[\u{1FAB0}-\u{1FABF}]|[\u{1FAC0}-\u{1FAFF}]|[\u{1FAD0}-\u{1FAFF}]|[\u{1FAE0}-\u{1FAFF}]|[\u{1FAF0}-\u{1FAFF}]/u;

    // Проверяем, содержит ли заголовок эмодзи
    if (emojiRegex.test(title)) {
      // Если есть эмодзи, берем второй символ (пропускаем эмодзи)
      return title.slice(1, 2);
    } else {
      // Если нет эмодзи, берем первую букву
      return title.slice(0, 1);
    }
  };

  console.log(task, 'ss');

  const progressPercentage = (progress / task.target_completion_count) * 100;

  return (
    <div
      className={`${styles.taskItem} ${isProcessing ? styles.processing : ''}`}
      onClick={handleClick}
    >
      <div className={styles.mainContent}>
        <div className={styles.iconWrapper}>
          {icon ? (
            <div className={styles.iconPictureWrapper}>
              <div className={styles.iconPicture}>{icon}</div>
            </div>
          ) : (
            <div className={styles.icon}>{getFirstLetter(task.title)}</div>
          )}
        </div>
        <div className={styles.titleWrapper}>
          <div className={styles.title}>{task.title}</div>
          <div>
            {task.rewards.map((reward, index) => (
              <div style={{display: 'flex', gap: 5}}>
                <ProgressBar progress={progress} allProgress={allProgress} />
                <Reward reward={reward.amount} key={index} />
              </div>
            ))}
          </div>
        </div>
        <div className={styles.buttonWrapper}>
          {isProcessing ? (
            <ButtonLoader />
          ) : progress === task.target_completion_count &&
            task.user_metadata.status !== 'CLAIMED' ? (
            <div className={styles.button}>Получить</div>
          ) : task.user_metadata.status === 'CLAIMED' ? (
            <div className={styles.cooldown}>
              <div>
                <CoolDownIcon className={styles.cooldownIcon} />
              </div>
              <div className={styles.cooldownTime}>
                <TimeDisplay
                  endDate={task.user_metadata.countdown_end_date ?? ''}
                  format="short"
                />
              </div>
            </div>
          ) : (
            <div className={styles.executeButton}>Выполнить</div>
          )}
        </div>
      </div>
      {/* {progress < task.target_completion_count &&
        task.user_metadata.status !== 'CLAIMED' && (
          <div className={styles.progressSection}>
            <div className={styles.progressBar}>
              <div
                className={styles.progressFill}
                style={{ width: `${progressPercentage}%` }}
              />
            </div>
            <div className={styles.progressText}>
              <span>{progress}</span>
              <span>/</span>
              <span>{task.target_completion_count}</span>
            </div>
          </div>
        )} */}
    </div>
  );
};

export default TaskItem;
